module.exports = (require("./helpers/browser/css-loader")(parcelRequire.resolve("g7N4e")));